import { render, staticRenderFns } from "./GoalFormDialog.vue?vue&type=template&id=5e97f7ac&scoped=true"
import script from "./GoalFormDialog.vue?vue&type=script&lang=js"
export * from "./GoalFormDialog.vue?vue&type=script&lang=js"
import style0 from "./GoalFormDialog.vue?vue&type=style&index=0&id=5e97f7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e97f7ac",
  null
  
)

export default component.exports